import { useLocation } from 'react-router-dom';

function useSearchParamsHelper() {
  const location = useLocation();

  const getProperFilterValues = (arrayFields: string[] = []) => {
    const queryParams = Object.fromEntries(
      new URLSearchParams(location.search)
    );
    return Object.entries(queryParams).reduce((acc: any, [key, value]) => {
      if (arrayFields.includes(key)) {
        acc[key] = value.split(',').map((v) => {
          if (v === 'true') return true;
          if (v === 'false') return false;
          if (!isNaN(Number(v))) return Number(v);
          return v;
        });
      } else if (value === 'true') {
        acc[key] = true;
      } else if (value === 'false') {
        acc[key] = false;
      } else if (!isNaN(Number(value))) {
        acc[key] = Number(value);
      } else {
        acc[key] = value;
      }

      return acc;
    }, {});
  };

  return { getProperFilterValues };
}

export default useSearchParamsHelper;
